import { computed, Ref, watch } from "vue";
import { MateSession } from "@/types/entity";
import { useGlobalUser } from "@/stores/globalUser";
import { useChat } from "@/stores/chat";
import { MAX_MESSAGE_COUNT } from "@/components/mobile/chat/constants";

export const useTriggerLoginForChat = (session: Ref<MateSession | null>) => {
  const user = useGlobalUser();
  const chat = useChat();
  const shouldPopLogin = computed(
    () =>
      user.isAnonymousUser &&
      !!session.value &&
      chat.sessionId2MessageList[session.value.id!] &&
      chat.sessionId2MessageList[session.value.id!].keyList.length >=
        MAX_MESSAGE_COUNT
  );
  watch(
    shouldPopLogin,
    (value) => {
      if (value) {
        user.loginModal.show = true;
      }
    },
    { immediate: true }
  );
  return { shouldPopLogin };
};
